import { getProduct, isProductPart, isUnavailableProduct } from './common';
import AddonComponent from '../components/AddonComponent';
import { ComponentIds, OutlinedComponent } from '@inter-ikea-core/core';
import ProductInfoComponent from '../components/ProductInfoComponent';
import UnavailableProductComponent from '../components/UnavailableProductComponent';
import LightSourceMetaComponent from '../components/LightSourceMetaComponent';
import AllowedHandleTypeComponent from '../components/AllowedHandleTypeComponent';
export const plannerComponentResolver = (_coreApi, products, unavailableProducts, productsNotInMarket, coreSpecificProducts, _isMobile) => {
    const componentBuilder = {
        build: (entity) => {
            const product = getProduct(entity, [
                ...products,
                ...unavailableProducts,
                ...productsNotInMarket,
                ...coreSpecificProducts
            ]);
            if (product) {
                entity.addComponent(new ProductInfoComponent(product.globalItemNo, product.name, product.type, product.design));
            }
            if (isUnavailableProduct(entity, unavailableProducts) && !isProductPart(entity)) {
                entity.addComponent(new UnavailableProductComponent());
                entity.addComponent(new OutlinedComponent());
                entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            }
            if (product?.meta?.addon) {
                entity.addComponent(new AddonComponent());
            }
            if (product?.meta?.allowedHandleTypes) {
                entity.addComponent(new AllowedHandleTypeComponent(product.meta.allowedHandleTypes));
            }
            if (product?.meta?.lightSourceType) {
                entity.addComponent(new LightSourceMetaComponent(product.meta?.lightSourceWidth, product.meta?.lightSourceType, product.meta?.lightAngle, product.meta?.lightIntensity));
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=plannerComponentResolver.js.map